(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    var cartPage = document.querySelector('.cart-page');
    var form = document.getElementById('cart-form');
    var contentBlock = document.getElementById('cart-page-content');
    var emptyBlock = document.getElementById('cart-page-empty');
    var itemsContainer = document.getElementById('cart-items-container');
    var subtotalEl = document.getElementById('cart-subtotal');
    var totalEl = document.getElementById('cart-total');
    var buttonTotalEl = document.getElementById('cart-button-total');

    function formatMoney(cents) {
      var whole = Math.round(cents / 100);
      var str = String(whole);
      var withCommas = str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var currency = (cartPage && cartPage.getAttribute('data-currency')) || 'USD';
      var symbol = currency === 'MXN' ? '$' : (currency === 'USD' ? '$' : currency + ' ');
      return symbol + ' ' + withCommas;
    }

    function formatAllPricesOnPage() {
      if (!cartPage) return;
      var els = cartPage.querySelectorAll('[data-cents]');
      for (var i = 0; i < els.length; i++) {
        var cents = parseInt(els[i].getAttribute('data-cents'), 10);
        if (!isNaN(cents)) els[i].textContent = formatMoney(cents);
      }
    }
    formatAllPricesOnPage();

    function updatePlusButtonsState() {
      if (!form) return;
      var rows = form.querySelectorAll('.cart-item[data-key]');
      var tooltipText = 'Inventario insuficiente';
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var maxVal = parseInt(row.getAttribute('data-max'), 10);
        if (isNaN(maxVal)) maxVal = 99;
        var input = row.querySelector('.cart-item__qty-input');
        var plusBtn = row.querySelector('.cart-item__qty-btn--plus');
        if (!input || !plusBtn) continue;
        var qty = parseInt(input.value, 10) || 0;
        if (qty >= maxVal) {
          plusBtn.disabled = true;
          plusBtn.setAttribute('title', tooltipText);
        } else {
          plusBtn.disabled = false;
          plusBtn.removeAttribute('title');
        }
      }
    }
    updatePlusButtonsState();

    function setCartPageFromCart(cart) {
      if (!cartPage || !cart) return;
      if (typeof cart.total_price !== 'number' || isNaN(cart.total_price)) return;
      if (cart.item_count === 0) {
        if (contentBlock) contentBlock.style.display = 'none';
        if (emptyBlock) emptyBlock.style.display = '';
        return;
      }
      if (contentBlock) contentBlock.style.display = '';
      if (emptyBlock) emptyBlock.style.display = 'none';
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
        subtotalEl.setAttribute('data-cents', cart.total_price);
      }
      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price);
        totalEl.setAttribute('data-cents', cart.total_price);
      }
      if (buttonTotalEl) {
        buttonTotalEl.textContent = formatMoney(cart.total_price);
        buttonTotalEl.setAttribute('data-cents', cart.total_price);
      }
      if (!itemsContainer) return;
      var keysInCart = cart.items.map(function(item) { return item.key; });
      cart.items.forEach(function(item) {
        var row = form.querySelector('.cart-item[data-key="' + item.key + '"]');
        if (row) {
          var input = row.querySelector('.cart-item__qty-input');
          var priceEl = row.querySelector('.cart-item__price');
          var maxQty = 99;
          if (item.variant && typeof item.variant.inventory_quantity === 'number') {
            maxQty = item.variant.inventory_quantity;
          }
          row.setAttribute('data-max', maxQty);
          if (input) input.value = item.quantity;
          if (priceEl) {
            priceEl.textContent = formatMoney(item.final_line_price);
            priceEl.setAttribute('data-cents', item.final_line_price);
          }
        }
      });
      var rows = itemsContainer.querySelectorAll('.cart-item');
      for (var i = 0; i < rows.length; i++) {
        var key = rows[i].getAttribute('data-key');
        if (keysInCart.indexOf(key) === -1) rows[i].remove();
      }
      updatePlusButtonsState();
    }

    window.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.cart) setCartPageFromCart(e.detail.cart);
    });

    if (form) {
      form.addEventListener('click', function(e) {
        var minusBtn = e.target.closest('.cart-item__qty-btn--minus');
        var plusBtn = e.target.closest('.cart-item__qty-btn--plus');
        var key = (minusBtn || plusBtn) && (minusBtn || plusBtn).getAttribute('data-key');
        if (!key) return;
        if (plusBtn && plusBtn.disabled) return;
        var row = form.querySelector('.cart-item[data-key="' + key + '"]');
        var input = row ? row.querySelector('.cart-item__qty-input') : null;
        if (!input) return;
        var maxVal = parseInt(row.getAttribute('data-max'), 10);
        if (isNaN(maxVal)) maxVal = 99;
        var qty = parseInt(input.value, 10) || 0;
        var delta = plusBtn ? 1 : -1;
        var newQty = qty + delta;
        if (newQty < 0) newQty = 0;
        if (newQty > maxVal) newQty = maxVal;

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: newQty })
        })
          .then(function(res) { return res.json().then(function(data) {
            if (!res.ok || data.description) throw new Error(data.description || 'Error al actualizar');
            return data;
          }); })
          .then(function(cart) {
            setCartPageFromCart(cart);
            window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function() {
            if (input) input.value = qty;
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
(function() {
  var BATCH_SIZE = 9;
  var grid = document.getElementById('collection-products-grid');
  if (!grid) return;

  var toolbar = document.querySelector('.collection-toolbar');
  var collectionUrl = (toolbar && toolbar.getAttribute('data-collection-url')) ||
    (document.querySelector('.collection-load-more') && document.querySelector('.collection-load-more').getAttribute('data-collection-url')) ||
    '';
  var totalServerPages = parseInt(grid.getAttribute('data-total-pages') || '1', 10);
  var loadMoreBtn = document.querySelector('.collection-load-more');
  var loadMoreWrapper = document.querySelector('.collection-load-more-wrapper');
  var filterBtns = toolbar ? toolbar.querySelectorAll('.collection-filter-btn') : [];
  var sortSelect = document.getElementById('collection-sort-by');

  var filterState = {
    activeTypes: [],
    nextServerPage: 2,
    loading: false
  };

  function normalizeType(s) {
    return (s || '').trim().replace(/\s+/g, ' ');
  }

  function typeMatches(a, b) {
    return normalizeType(a).toLowerCase() === normalizeType(b).toLowerCase();
  }

  function getActiveTypesFromParams(params) {
    var types = params.getAll('filter.p.product_type');
    if (!types.length) types = params.getAll('filter.p.t.product_type');
    if (!types.length) {
      var legacy = params.get('filter');
      if (legacy) types = legacy.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
    }
    return types;
  }

  function migrateShopifyFilterUrl() {
    var params = new URLSearchParams(window.location.search);
    var shopifyTypes = params.getAll('filter.p.product_type').concat(params.getAll('filter.p.t.product_type'));
    if (!shopifyTypes.length) return;
    var url = new URL(window.location.href);
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.delete('filter.p.t.product_type');
    shopifyTypes.forEach(function(t) { url.searchParams.append('filter', t); });
    window.history.replaceState({}, '', url.toString());
  }

  function getQueryParams() {
    var params = new URLSearchParams(window.location.search);
    return { filter: getActiveTypesFromParams(params), sort: params.get('sort_by') || '' };
  }

  function updateFilterUrl(activeTypes, sortBy) {
    var url = new URL(window.location.href);
    url.searchParams.delete('filter');
    url.searchParams.delete('filter.p.product_type');
    url.searchParams.delete('filter.p.t.product_type');
    activeTypes.forEach(function(t) { url.searchParams.append('filter', t); });
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    else url.searchParams.delete('sort_by');
    window.history.replaceState({}, '', url.toString());
  }

  function buildCollectionUrl(activeTypes, sortBy) {
    var url = new URL(collectionUrl, window.location.origin);
    activeTypes.forEach(function(t) { url.searchParams.append('filter', t); });
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    return url.toString();
  }

  function productMatchesType(card, activeTypes) {
    var type = card.getAttribute('data-product-type') || '';
    return activeTypes.some(function(t) { return typeMatches(t, type); });
  }

  function syncButtonsFromUrl() {
    var active = getQueryParams().filter;
    filterBtns.forEach(function(btn) {
      var t = btn.getAttribute('data-filter-type');
      var pressed = active.some(function(a) { return typeMatches(a, t); });
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    });
    return active;
  }

  function setGridLoading(loading) {
    grid.setAttribute('aria-busy', loading ? 'true' : 'false');
    if (loadMoreBtn) loadMoreBtn.disabled = loading;
  }

  function setLoadMoreVisible(visible) {
    if (loadMoreWrapper) loadMoreWrapper.style.display = visible ? '' : 'none';
  }

  function fetchCollectionPage(page, sortBy) {
    var url = new URL(collectionUrl, window.location.origin);
    if (sortBy) url.searchParams.set('sort_by', sortBy);
    if (page > 1) url.searchParams.set('page', String(page));
    return fetch(url.toString()).then(function(res) { return res.text(); });
  }

  function parseProductsFromHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sourceGrid = doc.querySelector('.collection-products');
    return sourceGrid ? sourceGrid.querySelectorAll('.collection-product') : [];
  }

  /* Patrón del grid (igual que Liquid): r 0,5=hero-top | r 4=full | resto=span-4 */
  function getLayoutRole(gridIndex) {
    var r = gridIndex % 9;
    if (r === 0 || r === 5) return 'hero';
    if (r === 4) return 'full';
    return 'card';
  }

  function extractProductParts(el) {
    var heroCard = el.querySelector('.collection-product-hero-card');
    var contentRoot = heroCard || el;
    var gallery = contentRoot.querySelector('.collection-product-gallery');
    var nav = contentRoot.querySelector('.collection-product-gallery-nav');
    var mask = contentRoot.querySelector('.collection-product-mask');

    var slideImgs = gallery ? gallery.querySelectorAll('.collection-product-gallery-slide img') : [];
    var heroSide = el.querySelector('.collection-product-hero-image img');
    var secondImgSrc = '';
    var secondImgAlt = '';
    if (heroSide) {
      secondImgSrc = heroSide.getAttribute('src') || '';
      secondImgAlt = heroSide.getAttribute('alt') || '';
    } else if (slideImgs.length > 1) {
      secondImgSrc = slideImgs[1].getAttribute('src') || '';
      secondImgAlt = slideImgs[1].getAttribute('alt') || '';
    } else if (slideImgs.length === 1) {
      secondImgSrc = slideImgs[0].getAttribute('src') || '';
      secondImgAlt = slideImgs[0].getAttribute('alt') || '';
    }

    return {
      productType: el.getAttribute('data-product-type') || '',
      price: el.getAttribute('data-price') || '',
      gallery: gallery ? gallery.cloneNode(true) : null,
      nav: nav ? nav.cloneNode(true) : null,
      mask: mask ? mask.cloneNode(true) : null,
      secondImgSrc: secondImgSrc,
      secondImgAlt: secondImgAlt
    };
  }

  function buildProductElement(parts, gridIndex) {
    var role = getLayoutRole(gridIndex);
    var el = document.createElement('div');
    el.className = 'collection-product';
    if (parts.productType) el.setAttribute('data-product-type', parts.productType);
    if (parts.price) el.setAttribute('data-price', parts.price);

    if (role === 'hero') {
      el.classList.add('collection-product--hero-top');
      if (parts.secondImgSrc) {
        var heroImageWrap = document.createElement('div');
        heroImageWrap.className = 'collection-product-hero-image';
        var heroImg = document.createElement('img');
        heroImg.src = parts.secondImgSrc;
        heroImg.alt = parts.secondImgAlt;
        heroImg.loading = 'lazy';
        heroImageWrap.appendChild(heroImg);
        el.appendChild(heroImageWrap);
      }
      var heroCard = document.createElement('div');
      heroCard.className = 'collection-product-hero-card';
      if (parts.gallery) heroCard.appendChild(parts.gallery);
      if (parts.nav) heroCard.appendChild(parts.nav);
      if (parts.mask) heroCard.appendChild(parts.mask);
      el.appendChild(heroCard);
    } else {
      el.classList.add('collection-product--card');
      el.classList.add(role === 'full' ? 'collection-product--full' : 'collection-product--span-4');
      if (parts.gallery) el.appendChild(parts.gallery);
      if (parts.nav) el.appendChild(parts.nav);
      if (parts.mask) el.appendChild(parts.mask);
    }
    return el;
  }

  function appendProductCard(sourceEl, useLayoutPattern) {
    var card;
    if (useLayoutPattern) {
      card = buildProductElement(extractProductParts(sourceEl), grid.querySelectorAll('.collection-product').length);
    } else {
      card = sourceEl.cloneNode(true);
    }
    grid.appendChild(card);
    initGallery(card);
    return card;
  }

  function collectMatchingProducts(activeTypes, startPage, sortBy, maxCount) {
    var collected = 0;
    var page = startPage;

    function tryNextPage() {
      if (collected >= maxCount || page > totalServerPages) {
        return Promise.resolve({ collected: collected, nextPage: page });
      }
      return fetchCollectionPage(page, sortBy).then(function(html) {
        var products = parseProductsFromHtml(html);
        products.forEach(function(el) {
          if (collected < maxCount && productMatchesType(el, activeTypes)) {
            appendProductCard(el, true);
            collected += 1;
          }
        });
        page += 1;
        return tryNextPage();
      });
    }

    return tryNextPage().then(function(result) {
      return { collected: result.collected, nextPage: result.nextPage };
    });
  }

  function hasMoreServerPages(nextPage) {
    return nextPage <= totalServerPages;
  }

  function loadFilteredBatch(append) {
    if (filterState.loading) return Promise.resolve();
    filterState.loading = true;
    setGridLoading(true);

    var sortBy = getQueryParams().sort;
    var startPage = append ? filterState.nextServerPage : 1;

    if (!append) grid.innerHTML = '';

    return collectMatchingProducts(filterState.activeTypes, startPage, sortBy, BATCH_SIZE)
      .then(function(result) {
        filterState.nextServerPage = result.nextPage;
        setLoadMoreVisible(hasMoreServerPages(filterState.nextServerPage));
      })
      .finally(function() {
        filterState.loading = false;
        setGridLoading(false);
      });
  }

  function applyFilter(activeTypes) {
    filterState.activeTypes = activeTypes.slice();
    filterState.nextServerPage = 1;
    updateFilterUrl(activeTypes, getQueryParams().sort);
    syncButtonsFromUrl();
    return loadFilteredBatch(false);
  }

  migrateShopifyFilterUrl();

  var initialFilters = syncButtonsFromUrl();
  if (sortSelect) sortSelect.value = getQueryParams().sort;

  if (initialFilters.length) {
    filterState.activeTypes = initialFilters;
    filterState.nextServerPage = 1;
    loadFilteredBatch(false);
  }

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var type = btn.getAttribute('data-filter-type');
      var pressed = btn.getAttribute('aria-pressed') === 'true';
      var q = getQueryParams();
      var active = q.filter.slice();

      if (pressed) {
        active = active.filter(function(t) { return !typeMatches(t, type); });
      } else if (!active.some(function(t) { return typeMatches(t, type); })) {
        active.push(type);
      }

      if (active.length === 0) {
        window.location.href = new URL(collectionUrl, window.location.origin).toString();
        return;
      }

      applyFilter(active);
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var q = getQueryParams();
      window.location.href = buildCollectionUrl(q.filter, sortSelect.value);
    });
  }

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
      if (filterState.loading) return;

      if (filterState.activeTypes.length) {
        loadFilteredBatch(true);
        return;
      }

      var currentPage = parseInt(loadMoreBtn.getAttribute('data-next-page') || '2', 10);
      filterState.loading = true;
      setGridLoading(true);

      fetchCollectionPage(currentPage, getQueryParams().sort)
        .then(function(html) {
          var products = parseProductsFromHtml(html);
          products.forEach(function(el) { appendProductCard(el, false); });
          currentPage += 1;
          loadMoreBtn.setAttribute('data-next-page', currentPage);
          if (currentPage > totalServerPages) {
            setLoadMoreVisible(false);
          }
        })
        .finally(function() {
          filterState.loading = false;
          setGridLoading(false);
        });
    });
  }

  function initGallery(card) {
    var slider = card.querySelector('.collection-product-gallery-slider');
    var prevBtn = card.querySelector('.collection-product-gallery-prev');
    var nextBtn = card.querySelector('.collection-product-gallery-next');
    if (!slider || !prevBtn || !nextBtn) return;
    var slides = slider.querySelectorAll('.collection-product-gallery-slide');
    if (slides.length <= 1) {
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      return;
    }
    var currentIndex = 0;
    function updateButtons() {
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= slides.length - 1;
    }
    function scrollToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      currentIndex = index;
      slider.scrollTo({ left: slider.clientWidth * index, behavior: 'smooth' });
      updateButtons();
    }
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToSlide(currentIndex - 1);
    });
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToSlide(currentIndex + 1);
    });
    slider.addEventListener('scroll', function() {
      var slideWidth = slider.clientWidth;
      if (slideWidth <= 0) return;
      var newIndex = Math.round(slider.scrollLeft / slideWidth);
      if (newIndex !== currentIndex) {
        currentIndex = newIndex;
        updateButtons();
      }
    });
    updateButtons();
  }

  grid.querySelectorAll('.collection-product').forEach(initGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"]) return;
  try {
    
(function() {
  var form = document.querySelector('.contact-form-form form');
  if (!form) return;
  var textarea = form.querySelector('textarea.contact-form-form-input');
  if (!textarea) return;

  function resize() {
    textarea.style.height = 'auto';
    textarea.style.height = Math.max(textarea.scrollHeight, 56) + 'px';
  }

  textarea.addEventListener('input', resize);
  textarea.addEventListener('focus', resize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discover-products"] && !Shopify.designMode) return;
  try {
    
(function() {
var cards = document.querySelectorAll('.discover-products-card');
cards.forEach(function(card) {
var slider = card.querySelector('.discover-products-gallery-slider');
var prevBtn = card.querySelector('.discover-products-gallery-prev');
var nextBtn = card.querySelector('.discover-products-gallery-next');
if (!slider) return;
var slides = slider.querySelectorAll('.discover-products-gallery-slide');
var startIndex = slides.length > 1 ? 1 : 0;
var currentIndex = startIndex;
function getSlideWidth() {
  return slides[0] ? slides[0].offsetWidth : slider.clientWidth;
}
slider.scrollTo({ left: getSlideWidth() * startIndex, behavior: 'auto' });
if (!prevBtn || !nextBtn) return;
function updateButtons() {
prevBtn.disabled = currentIndex <= 0;
nextBtn.disabled = currentIndex >= slides.length - 1;
}
function scrollToSlide(index) {
if (index < 0 || index >= slides.length) return;
currentIndex = index;
var slideWidth = getSlideWidth();
slider.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
updateButtons();
}
prevBtn.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
scrollToSlide(currentIndex - 1);
});
nextBtn.addEventListener('click', function(e) {
e.preventDefault();
e.stopPropagation();
scrollToSlide(currentIndex + 1);
});
slider.addEventListener('scroll', function() {
var slideWidth = getSlideWidth();
if (slideWidth <= 0) return;
var newIndex = Math.round(slider.scrollLeft / slideWidth);
if (newIndex !== currentIndex) {
currentIndex = newIndex;
updateButtons();
}
});
updateButtons();
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function() {
const faqQuestions = document.querySelectorAll('.faq-question');
if (!faqQuestions.length) return;

faqQuestions.forEach(function(question) {
question.addEventListener('click', function() {
const isExpanded = this.getAttribute('aria-expanded') === 'true';
const answerWrapper = this.nextElementSibling;
if (!answerWrapper) return;

// Cerrar todas las otras FAQs
faqQuestions.forEach(function(otherQuestion) {
if (otherQuestion !== question) {
otherQuestion.setAttribute('aria-expanded', 'false');
const otherAnswerWrapper = otherQuestion.nextElementSibling;
if (otherAnswerWrapper && otherAnswerWrapper.classList.contains('faq-answer-wrapper')) {
otherAnswerWrapper.style.height = '0';
}
}
});

// Toggle de la FAQ actual
if (isExpanded) {
this.setAttribute('aria-expanded', 'false');
answerWrapper.style.height = '0';
} else {
this.setAttribute('aria-expanded', 'true');
// Calcular la altura real del contenido
answerWrapper.style.height = 'auto';
const height = answerWrapper.scrollHeight;
answerWrapper.style.height = '0';
// Forzar reflow para que la transición funcione
answerWrapper.offsetHeight;
answerWrapper.style.height = height + 'px';
}
});
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
const slider = document.querySelector('.featured-products-wrapper');
const prevButton = document.querySelector('.slider-nav-button--prev');
const nextButton = document.querySelector('.slider-nav-button--next');

if (!slider || !prevButton || !nextButton) return;

function updateButtons() {
const isAtStart = slider.scrollLeft <= 0; const isAtEnd=slider.scrollLeft>= slider.scrollWidth - slider.clientWidth - 1;

  prevButton.disabled = isAtStart;
  nextButton.disabled = isAtEnd;
  }

  prevButton.addEventListener('click', function() {
  const cardWidth = slider.querySelector('.featured_products-card').offsetWidth;
  slider.scrollBy({
  left: -cardWidth,
  behavior: 'smooth'
  });
  });

  nextButton.addEventListener('click', function() {
  const cardWidth = slider.querySelector('.featured_products-card').offsetWidth;
  slider.scrollBy({
  left: cardWidth,
  behavior: 'smooth'
  });
  });

  slider.addEventListener('scroll', updateButtons);
  updateButtons();
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
var header = document.querySelector('header');
if (!header) return;
var headerCartCount = document.getElementById('cart-header-count');

// Calibración: en qué punto del scroll el header cambia de fondo
// triggerRatio = 0.5  → cambia al 50% de la primera sección
// triggerRatio = 0.85 → cambia al 85% de la primera sección
// triggerRatio = 1    → cambia cuando sales por completo de la primera sección
var triggerRatio = 0.85;
var vhMax = 2;      // tope máximo en viewports: si la 1ª sección es muy alta, el threshold no supera esto (2 = dos pantallas)
var vhMin = 0.4;    // tope mínimo en viewports (evita que cambie demasiado pronto)

function getThreshold() {
var th = window.innerHeight * 0.8;
var sections = document.querySelectorAll('.shopify-section');
for (var i = 0; i < sections.length; i++) {
if (!sections[i].contains(header)) {
var firstSectionHeight = sections[i].offsetHeight;
th = firstSectionHeight * triggerRatio;
th = Math.min(th, window.innerHeight * vhMax);
th = Math.max(th, window.innerHeight * vhMin);
break;
}
}
return th;
}

var threshold = getThreshold();

function onScroll() {
header.classList.toggle('header--scrolled', window.scrollY > threshold);
}
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', function() {
threshold = getThreshold();
onScroll();
});

function updateHeaderCartCount(cart) {
if (!headerCartCount || !cart) return;
headerCartCount.textContent = cart.item_count;
headerCartCount.style.display = cart.item_count > 0 ? '' : 'none';
}

window.addEventListener('cart:updated', function(e) {
if (e.detail && e.detail.cart) updateHeaderCartCount(e.detail.cart);
});

var hamburger = document.getElementById('nav-hamburger');
var mobileMenu = document.getElementById('nav-mobile-menu');
if (!hamburger || !mobileMenu) return;

function toggleMenu() {
hamburger.classList.toggle('active');
mobileMenu.classList.toggle('active');
document.body.style.overflow = mobileMenu.classList.contains('active') ? 'hidden' : '';
}
hamburger.addEventListener('click', toggleMenu);

mobileMenu.querySelectorAll('.nav-mobile-button').forEach(function(btn) {
btn.addEventListener('click', function() {
hamburger.classList.remove('active');
mobileMenu.classList.remove('active');
document.body.style.overflow = '';
});
});
mobileMenu.addEventListener('click', function(e) {
if (e.target === mobileMenu) {
hamburger.classList.remove('active');
mobileMenu.classList.remove('active');
document.body.style.overflow = '';
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-product"]) return;
  try {
    
(function() {
const section = document.querySelector('.hero-product');
if (!section) return;

const galleryWrapper = section.querySelector('#hero-product-gallery-wrapper');
const slider = section.querySelector('.hero-product__gallery-slider');
const prevButton = section.querySelector('.hero-product__gallery-prev');
const nextButton = section.querySelector('.hero-product__gallery-next');
const slides = slider ? slider.querySelectorAll('.hero-product__gallery-slide') : [];
if (prevButton && nextButton && slides.length > 1) {
  let currentIndex = 0;
  function updateButtons() {
    prevButton.disabled = currentIndex <= 0;
    nextButton.disabled = currentIndex >= slides.length - 1;
  }
  function scrollToSlide(index) {
    if (index < 0 || index >= slides.length) return;
    currentIndex = index;
    const slideWidth = slider.clientWidth;
    slider.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    updateButtons();
  }
  prevButton.addEventListener('click', function() { scrollToSlide(currentIndex - 1); });
  nextButton.addEventListener('click', function() { scrollToSlide(currentIndex + 1); });
  slider.addEventListener('scroll', function() {
    const slideWidth = slider.clientWidth;
    if (slideWidth <= 0) return;
    const newIndex = Math.round(slider.scrollLeft / slideWidth);
    if (newIndex !== currentIndex) {
      currentIndex = newIndex;
      updateButtons();
    }
  });
  updateButtons();
}

const variantSelect = section.querySelector('#product-variant-select');
if (variantSelect) {
  variantSelect.addEventListener('change', function() {
    const selectedOption = this.options[this.selectedIndex];
    const priceText = selectedOption.textContent.split(' - ')[1];
    const priceWrapper = section.querySelector('.hero-product__price');
    if (priceWrapper && priceText) priceWrapper.textContent = priceText;
  });
}

// Card de producto combinado: click en la card navega, click en "+" añade al carrito
const combinarCard = section.querySelector('.hero-product__combinar-card');
if (combinarCard) {
  const addBtn = combinarCard.querySelector('[data-related-add]');
  const variantId = combinarCard.getAttribute('data-related-variant-id');
  const relatedUrl = combinarCard.getAttribute('data-related-url');

  // Navegar al producto si se hace click en la card (pero no en el botón "+")
  if (relatedUrl) {
    combinarCard.addEventListener('click', function(event) {
      if (event.target.closest('[data-related-add]')) return;
      window.location.href = relatedUrl;
    });
  }

  // Añadir el producto combinado al carrito al hacer click en el "+"
  if (addBtn && variantId) {
    addBtn.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })
      .then(function() {
        // Abrir el cart-drawer
        var overlay = document.getElementById('cart-drawer-overlay');
        var drawer = document.getElementById('cart-drawer');
        if (drawer && overlay) {
          drawer.classList.add('is-open');
          overlay.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          overlay.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }

        // Actualizar badge del carrito con el nuevo total
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            var badge = document.getElementById('cart-drawer-close-count');
            if (badge) {
              badge.textContent = cart.item_count;
              badge.style.display = cart.item_count > 0 ? '' : 'none';
            }
          });
      })
      .catch(function(error) {
        console.error('Error adding related product to cart', error);
      });
    });
  }
}
})();
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
var section = document.querySelector('.product-reviews');
if (!section) return;

var slider = document.getElementById('product-reviews-slider');
var slides = section.querySelectorAll('.product-reviews-slide');
var total = slides.length;
var currentEl = document.getElementById('product-reviews-current');
var totalEl = document.getElementById('product-reviews-total');
var prevBtn = section.querySelector('.product-reviews-nav-btn--prev');
var nextBtn = section.querySelector('.product-reviews-nav-btn--next');

if (!slider || total === 0 || !currentEl || !totalEl || !prevBtn || !nextBtn) return;

totalEl.textContent = total;
var index = 0;

function goTo(i) {
index = Math.max(0, Math.min(i, total - 1));
var pct = total > 1 ? (index * 100 / total) : 0;
slider.style.transform = 'translateX(-' + pct + '%)';
currentEl.textContent = index + 1;
prevBtn.disabled = index <= 0; nextBtn.disabled=index>= total - 1;
  }

  prevBtn.addEventListener('click', function() { goTo(index - 1); });
  nextBtn.addEventListener('click', function() { goTo(index + 1); });

  slider.style.display = 'flex';
  slider.style.width = (total * 100) + '%';
  slider.style.transition = 'transform 0.35s ease';
  Array.prototype.forEach.call(slides, function(s) {
  s.style.width = (100 / total) + '%';
  s.style.flexShrink = '0';
  });

  goTo(0);
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  const sliderWrapper = document.getElementById('products-slider-wrapper');
  if (!sliderWrapper) return;

  const slides = sliderWrapper.querySelectorAll('.products-slider-slide');
  const totalSlides = slides.length;

  if (totalSlides === 0) return;

  let currentIndex = 0;

  function updateSlider() {
    slides.forEach(function(slide, index) {
      if (index === currentIndex) {
        slide.classList.add('products-slider-slide--active');
      } else {
        slide.classList.remove('products-slider-slide--active');
      }
    });
  }

  function goToSlide(index) {
    if (index < 0) {
      currentIndex = totalSlides - 1;
    } else if (index >= totalSlides) {
      currentIndex = 0;
    } else {
      currentIndex = index;
    }
    updateSlider();
  }

  const prevButtons = sliderWrapper.querySelectorAll('[data-products-slider-prev]');
  const nextButtons = sliderWrapper.querySelectorAll('[data-products-slider-next]');

  prevButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      goToSlide(currentIndex - 1);
    });
  });

  nextButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      goToSlide(currentIndex + 1);
    });
  });

  function initSlider() {
    updateSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlider);
  } else {
    setTimeout(initSlider, 100);
  }

  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      updateSlider();
    }, 250);
  });
})();

// Galería de imágenes dentro de .products-slider-slide-image-left (para todos los productos) con efecto GSAP/parallax
if (typeof gsap !== 'undefined' && typeof Observer !== 'undefined' && typeof CustomEase !== 'undefined') {
  gsap.registerPlugin(Observer, CustomEase);
  CustomEase.create("slideshow-wipe", "0.6, 0.08, 0.02, 0.99");
}

function initSlideShow(el) {
  const ui = {
    el,
    slides: Array.from(el.querySelectorAll('[data-slideshow="slide"]')),
    inner: Array.from(el.querySelectorAll('[data-slideshow="parallax"]')),
    thumbs: Array.from(el.querySelectorAll('[data-slideshow="thumb"]'))
  };

  let current = 0;
  const length = ui.slides.length;
  let animating = false;
  let observer;
  let animationDuration = 0.9;

  ui.slides.forEach((slide, index) => {
    slide.setAttribute('data-index', index);
  });

  ui.thumbs.forEach((thumb, index) => {
    thumb.setAttribute('data-index', index);
  });

  ui.slides[current].classList.add('is--current');
  ui.thumbs[current].classList.add('is--current');

  function navigate(direction, targetIndex = null) {
    if (animating) return;

    animating = true;
    observer && observer.disable();

    const previous = current;
    current =
      targetIndex !== null && targetIndex !== undefined
        ? targetIndex
        : direction === 1
          ? current < length - 1
            ? current + 1
            : 0
          : current > 0
            ? current - 1
            : length - 1;

    const currentSlide = ui.slides[previous];
    const currentInner = ui.inner[previous];
    const upcomingSlide = ui.slides[current];
    const upcomingInner = ui.inner[current];

    gsap.timeline({
      defaults: {
        duration: animationDuration,
        ease: 'slideshow-wipe'
      },
      onStart: function() {
        upcomingSlide.classList.add('is--current');
        ui.thumbs[previous].classList.remove('is--current');
        ui.thumbs[current].classList.add('is--current');
      },
      onComplete: function() {
        currentSlide.classList.remove('is--current');
        animating = false;
        setTimeout(() => observer && observer.enable(), animationDuration * 1000);
      }
    })
    .to(currentSlide, { xPercent: -direction * 100 }, 0)
    .to(currentInner, { xPercent: direction * 50 }, 0)
    .fromTo(upcomingSlide, { xPercent: direction * 100 }, { xPercent: 0 }, 0)
    .fromTo(upcomingInner, { xPercent: -direction * 50 }, { xPercent: 0 }, 0);
  }

  function onClick(event) {
    const targetIndex = parseInt(event.currentTarget.getAttribute('data-index'), 10);
    if (targetIndex === current || animating) return;
    const direction = targetIndex > current ? 1 : -1;
    navigate(direction, targetIndex);
  }

  ui.thumbs.forEach(thumb => {
    thumb.addEventListener('click', onClick);
  });

  if (typeof Observer !== 'undefined') {
    observer = Observer.create({
      target: ui.el,
      type: 'wheel,touch,pointer',
      onLeft: () => { if (!animating) navigate(1); },
      onRight: () => { if (!animating) navigate(-1); },
      onWheel: (event) => {
        if (animating) return;
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
          if (event.deltaX > 50) {
            navigate(1);
          } else if (event.deltaX < -50) {
            navigate(-1);
          }
        }
      },
      wheelSpeed: -1,
      tolerance: 10
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let wrappers = document.querySelectorAll('[data-slideshow="wrap"]');
  wrappers.forEach(wrap => initSlideShow(wrap));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-media"] && !Shopify.designMode) return;
  try {
    
(function() {
  var slider = document.querySelector('.social-media-scroll-container');
  var sliderWrapper = document.querySelector('.social-media-wrapper');
  var prevButton = document.querySelector('.social-media-nav-button--prev');
  var nextButton = document.querySelector('.social-media-nav-button--next');

  if (!slider || !prevButton || !nextButton || !sliderWrapper) return;

  var slides = slider.querySelectorAll('.social-media-slide');
  var totalSlides = slides.length;
  if (totalSlides === 0) return;

  var MOBILE_BREAKPOINT = 479;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function getSlideWidth() {
    return slides[0].offsetWidth || 420;
  }

  function getStepPx() {
    var slide = slides[0];
    if (!slide) return 420;
    var style = window.getComputedStyle(slide);
    var width = slide.offsetWidth;
    var marginLeft = parseFloat(style.marginLeft) || 0;
    var marginRight = parseFloat(style.marginRight) || 0;
    return width + marginLeft + marginRight;
  }

  function getTotalWidth() {
    return totalSlides * getStepPx();
  }

  var currentOffset = 0;
  var currentIndex = 0;

  function getMaxOffset() {
    var containerWidth = sliderWrapper.clientWidth;
    var totalWidth = getTotalWidth();
    if (totalWidth <= containerWidth) return 0;
    return totalWidth - containerWidth;
  }

  function updateButtons() {
    if (isMobile()) {
      prevButton.disabled = currentIndex <= 0;
      nextButton.disabled = currentIndex >= totalSlides - 1;
    } else {
      var maxOff = getMaxOffset();
      prevButton.disabled = currentOffset <= 0;
      nextButton.disabled = currentOffset >= maxOff;
    }
  }

  function setOffset(px) {
    var maxOff = getMaxOffset();
    currentOffset = Math.max(0, Math.min(px, maxOff));
    slider.style.transform = 'translateX(' + (-currentOffset) + 'px)';
    updateButtons();
  }

  function goToIndex(index) {
    currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
    var step = getStepPx();
    currentOffset = currentIndex * step;
    slider.style.transform = 'translateX(' + (-currentOffset) + 'px)';
    updateButtons();
  }

  prevButton.addEventListener('click', function(e) {
    e.stopPropagation();
    if (isMobile()) {
      goToIndex(currentIndex - 1);
    } else {
      setOffset(currentOffset - getStepPx());
    }
  });

  nextButton.addEventListener('click', function(e) {
    e.stopPropagation();
    if (isMobile()) {
      goToIndex(currentIndex + 1);
    } else {
      setOffset(currentOffset + getStepPx());
    }
  });

  var resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (isMobile()) {
        var step = getStepPx();
        currentIndex = step > 0 ? Math.min(Math.round(currentOffset / step), totalSlides - 1) : 0;
        goToIndex(currentIndex);
      } else {
        currentIndex = 0;
        var maxOff = getMaxOffset();
        if (currentOffset > maxOff) setOffset(maxOff);
        else updateButtons();
      }
    }, 250);
  });

  updateButtons();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.stats-section');
    if (!section) return;

    var slider = section.querySelector('.product-reviews-slider');
    var slides = section.querySelectorAll('.product-reviews-slide');
    var total = slides.length;
    var currentEl = section.querySelector('[id^="stats-current-"]');
    var totalEl = section.querySelector('[id^="stats-total-"]');
    var lineFill = section.querySelector('.product-reviews-counter-line--fill');
    var prevBtn = section.querySelector('.product-reviews-nav-btn--prev');
    var nextBtn = section.querySelector('.product-reviews-nav-btn--next');

    if (!slider || total === 0 || !currentEl || !totalEl || !prevBtn || !nextBtn) return;

    totalEl.textContent = total;
    var index = 0;

    function goTo(i) {
      index = Math.max(0, Math.min(i, total - 1));
      var pct = total > 1 ? (index * 100 / total) : 0;
      slider.style.transform = 'translateX(-' + pct + '%)';
      currentEl.textContent = index + 1;
      if (lineFill) {
        var fillPct = total > 0 ? ((index + 1) / total) * 100 : 0;
        lineFill.style.width = fillPct + '%';
      }
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= total - 1;
    }

    prevBtn.addEventListener('click', function() { goTo(index - 1); });
    nextBtn.addEventListener('click', function() { goTo(index + 1); });

    slider.style.display = 'flex';
    slider.style.width = (total * 100) + '%';
    slider.style.transition = 'transform 0.35s ease';
    Array.prototype.forEach.call(slides, function(s) {
      s.style.width = (100 / total) + '%';
      s.style.flexShrink = '0';
    });

    goTo(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["technology"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const techButtons = document.querySelectorAll('.technology-button');
    const techCard = document.getElementById('technology-card');
    const techCardTitle = document.getElementById('tech-card-title');
    const techCardDescription = document.getElementById('tech-card-description');
    const techCardImage = document.getElementById('tech-card-image');
    const techCardButton = document.getElementById('tech-card-button');
    const techCardClose = document.querySelector('.technology-card-close');

    if (!techCard || !techCardTitle || !techCardDescription || !techCardImage || !techCardButton) return;

    techButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Remover active de todos los botones
        techButtons.forEach(function(btn) {
          btn.classList.remove('active');
        });
        
        // Agregar active al botón clickeado
        this.classList.add('active');
        
        // Obtener datos del botón
        const title = this.getAttribute('data-tech-title');
        const description = this.getAttribute('data-tech-description');
        const image = this.getAttribute('data-tech-image');
        const url = this.getAttribute('data-tech-url');
        
        // Actualizar la tarjeta
        if (title) techCardTitle.textContent = title;
        if (description) techCardDescription.textContent = description;
        if (image) {
          techCardImage.src = image;
          techCardImage.alt = title || 'Technology';
          techCardImage.style.display = 'block';
        } else {
          techCardImage.style.display = 'none';
        }
        if (url) techCardButton.href = url;
        
        // Mostrar la tarjeta
        techCard.classList.add('active');
      });
    });

    // Cerrar tarjeta al hacer click fuera
    document.addEventListener('click', function(e) {
      if (techCard.classList.contains('active')) {
        if (!techCard.contains(e.target) && !Array.from(techButtons).some(btn => btn.contains(e.target))) {
          techCard.classList.remove('active');
          techButtons.forEach(function(btn) {
            btn.classList.remove('active');
          });
        }
      }
    });

    // Cerrar tarjeta con el botón de cierre
    if (techCardClose) {
      techCardClose.addEventListener('click', function(e) {
        e.stopPropagation();
        techCard.classList.remove('active');
        techButtons.forEach(function(btn) {
          btn.classList.remove('active');
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["viewed-products"] && !Shopify.designMode) return;
  try {
    
(function() {
const section = document.querySelector('.viewed-products');
if (!section) return;

const imageContainer = section.querySelector('.viewed-products-image-container');
if (imageContainer) {
const heroImg = document.getElementById('viewed-products-hero-image');
const defaultImageUrl = imageContainer ? imageContainer.getAttribute('data-default-image') : null;
const items = section.querySelectorAll('.discover-products-slider-item[data-second-image]');
var restoreDefaultTimeout = null;

function setDefaultImage() {
if (heroImg && defaultImageUrl) {
heroImg.src = defaultImageUrl;
heroImg.classList.add('is-visible');
}
}

items.forEach(function(item) {
item.addEventListener('mouseenter', function() {
if (restoreDefaultTimeout) {
clearTimeout(restoreDefaultTimeout);
restoreDefaultTimeout = null;
}
var url = this.getAttribute('data-second-image');
if (heroImg && url) {
heroImg.src = url;
heroImg.classList.add('is-visible');
}
});
item.addEventListener('mouseleave', function() {
restoreDefaultTimeout = setTimeout(function() {
restoreDefaultTimeout = null;
setDefaultImage();
}, 80);
});
});
}

if (window.innerWidth > 479) return;

const sliderWrapper = document.getElementById('viewed-products-slider-wrapper');
const prevButton = section.querySelector('.discover-products-nav-button--prev');
const nextButton = section.querySelector('.discover-products-nav-button--next');

if (!sliderWrapper || !prevButton || !nextButton) return;

const slides = sliderWrapper.querySelectorAll('.discover-products-slider-item');
const totalSlides = Math.min(slides.length, 4);
if (totalSlides === 0) return;

var currentIndex = 0;
var REM_PX = 16;

function getSlideStepPx() {
  var cw = sliderWrapper.clientWidth;
  return cw + (2 * REM_PX);
}

function goToSlide(index) {
  currentIndex = Math.max(0, Math.min(index, totalSlides - 1));
  var step = getSlideStepPx();
  var targetScroll = currentIndex * step;
  sliderWrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
  prevButton.disabled = currentIndex <= 0;
  nextButton.disabled = currentIndex >= totalSlides - 1;
}

function updateButtons() {
  var scrollLeft = sliderWrapper.scrollLeft;
  var step = getSlideStepPx();
  var tolerance = Math.min(15, step * 0.15);
  currentIndex = Math.round(scrollLeft / step);
  currentIndex = Math.max(0, Math.min(currentIndex, totalSlides - 1));
  prevButton.disabled = currentIndex <= 0;
  nextButton.disabled = currentIndex >= totalSlides - 1;
}

prevButton.addEventListener('click', function() {
  goToSlide(currentIndex - 1);
});
nextButton.addEventListener('click', function() {
  goToSlide(currentIndex + 1);
});
sliderWrapper.addEventListener('scroll', updateButtons);

var resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    if (window.innerWidth <= 479) {
      goToSlide(currentIndex);
      updateButtons();
    }
  }, 250);
});

goToSlide(0);
})();

  } catch(e) { console.error(e); }
})();
})();
